import { getCoverThumbUrl } from '../../utils/coverUrl';
import React from 'react';
import { Star, Check } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * BookRecommendationsPanel — admin selects up to 10 books to show in the
 * home-page "Recommended" rail. Click-to-toggle UI.
 *
 * Extracted from AdminSettings.jsx (2026-05-29).
 */
const BookRecommendationsPanel = ({
  books,
  recommendedBooks,
  savingRecommendations,
  onToggleBook,
  onSave,
  getCoverUrl,
}) => {
  return (
    <div className="bg-white/5 rounded-xl border border-white/10 p-6" data-testid="recommendations-section">
      <div className="flex items-center mb-6">
        <Star className="h-6 w-6 text-yellow-500 mr-2" />
        <h2 className="text-xl font-bold text-white">Book Recommendations</h2>
      </div>

      <p className="text-gray-400 text-sm mb-4">
        Select up to 10 books to recommend to users. These will be featured on the home page.
      </p>

      <div className="flex items-center justify-between mb-4">
        <span className="text-gray-400">Selected: {recommendedBooks.length}/10</span>
        <Button
          onClick={onSave}
          disabled={savingRecommendations}
          className="bg-yellow-600 hover:bg-yellow-700"
          data-testid="save-recommendations-btn"
        >
          {savingRecommendations ? 'Saving...' : 'Save Recommendations'}
        </Button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 max-h-96 overflow-y-auto">
        {books.map((book) => {
          const isSelected = recommendedBooks.includes(book.id);
          return (
            <div
              key={book.id}
              onClick={() => onToggleBook(book.id)}
              className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all ${
                isSelected
                  ? 'border-yellow-500 ring-2 ring-yellow-500/50'
                  : 'border-transparent hover:border-white/30'
              }`}
              data-testid={`recommend-book-${book.id}`}
            >
              <img
                src={getCoverThumbUrl(book.cover_image_url)}
                alt={book.title}
                className="w-full h-32 object-cover"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80';
                }}
              />
              {isSelected && (
                <div className="absolute inset-0 bg-yellow-500/30 flex items-center justify-center">
                  <div className="bg-yellow-500 text-white rounded-full p-1">
                    <Check className="h-5 w-5" />
                  </div>
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2">
                <p className="text-white text-xs font-medium truncate">{book.title}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookRecommendationsPanel;
